import './_SmallInfoCard.scss';
import Card from 'react-bootstrap/Card';
import { ISmallCardInfo } from '../types/ISmallCardInfo';
import { litrals } from '../../../../../constants/Litrals';

const SmallInfoCard = (props: ISmallCardInfo) => {
  return (
    <Card
      className="smallinfocard-container"
      data-testid="smallinfocard-container"
    >
      <i className="fa fa-info-circle" aria-hidden="true"></i>
      <Card.Text className="card-text">
        {props.contentbeforelink}
        <button
          className="click-here"
          onClick={() => props.onClick()}
          tabIndex={0}
          data-testid="click-here"
          role="button"
        >
          {props.clickHere ? props.clickHere : litrals.clickHere}
        </button>
        {props.contentafterlink}
      </Card.Text>
    </Card>
  );
};
export default SmallInfoCard;
